import React from 'react'
import { LayoutPageWrapper } from 'goustouicomponents/dist/LayoutPageWrapper'
import { Heading } from 'goustouicomponents/dist/Heading'
import css from './OurLocation.module.css'

const OurLocation = () => (
  <section className={css.wrapper}>
    <LayoutPageWrapper padding="large-screens-only">
      <Heading type="h2" size="fontStyleXL" isCenter>
        Where we’re based
      </Heading>
      <div className={css.columnWrapper}>
        <div className={css.column}>
          <div>
            <Heading type="h3" size="fontStyleM">
              Shepherd’s Bush, London
            </Heading>
            <p className={css.text}>
              Hidden away behind Shepherd’s Bush Green you’ll find Gousto HQ. Our London office holds the tech team, finance team, people team, marketing team, food team, proposition team, and customer care team... and we’re growing all the time.
            </p>
          </div>
          <iframe
            className={css.googleMaps}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7643.8469285112615!2d-0.22209376957357566!3d51.5020501190148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760e253c042995%3A0x4bf29e9fb84765db!2sGousto!5e0!3m2!1sen!2suk!4v1605482317559!5m2!1sen!2suk"
            title="London location"
          />
        </div>
        <div className={css.column}>
          <div>
            <Heading type="h3" size="fontStyleM">
              Spalding, Lincolnshire
            </Heading>
            <p className={css.text}>
              Sprawled over the fields of Spalding are our Gousto warehouses, where every box starts its journey. Our Spalding sites hold the ops team, the logistics team, the food tech team, and even more of our customer care team.
            </p>
          </div>
          <iframe
            className={css.googleMaps}
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2413.6886730449014!2d-0.14454284957502078!3d52.773888877361564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTLCsDQ2JzI2LjAiTiAwwrAwOCczMi4wIlc!5e0!3m2!1sen!2suk!4v1710244851085!5m2!1sen!2su"
            title="Spalding location"
          />
        </div>
        <div className={css.column}>
          <div>
            <Heading type="h3" size="fontStyleM">
              Warrington, Cheshire
            </Heading>
            <p className={css.text}>
              At over 300,000 sq.ft, Warrington is our newest and largest fulfilment site. With tonnes of tech and automation, this is where the fulfilment, technical and engineering teams get Gousto boxes prepped and dispatched at top speed.
            </p>
          </div>
          <iframe
            className={css.googleMaps}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2378.091911097312!2d-2.6524552843302156!3d53.413182377404155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b032fef0e148b%3A0x421a1f8e9285046b!2sGousto!5e0!3m2!1sen!2suk!4v1643364851038!5m2!1sen!2suk"
            title="Warrington location"
          />
        </div>
      </div>
    </LayoutPageWrapper>
  </section>
)

export { OurLocation }
